import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcServiceSwitcher = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "m11.252 18.331 3.623 2.091a2 2 0 0 0 2 0l4.17-2.407a2 2 0 0 0 1-1.732v-4.816a2 2 0 0 0-1-1.732l-3.753-2.167.003.149v4.816a4 4 0 0 1-2 3.464l-4.043 2.334Z",
  fill: "var(--mds-nav-icon-weak)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M8.126 3.578a2 2 0 0 1 2 0l4.17 2.407a2 2 0 0 1 1 1.732v4.816a2 2 0 0 1-1 1.732l-4.17 2.408a2 2 0 0 1-2 0l-4.17-2.408a2 2 0 0 1-1-1.732V7.717a2 2 0 0 1 1-1.732l4.17-2.407Z",
  fill: "var(--mds-nav-icon-accent)"
})), "IcServiceSwitcher");

export { IcServiceSwitcher };
//# sourceMappingURL=ic-service-switcher.js.map
